<div
    animate.enter="animate-fade-in-slow"
    animate.leave="animate-fade-out-slow"
    class="fixed inset-0 flex size-full bg-dialog-layer motion-reduce:animate-none"
>
    <button
        class="h-full w-0 sm:w-1/3 md:w-2/5 lg:w-3/5"
        type="button"
        [attr.aria-label]="'AI.MINIMIZE' | translate"
        (click)="close()"
    ></button>
    <section
        cdkTrapFocus
        cdkTrapFocusAutoCapture
        class="flex size-full flex-col gap-y-8 bg-surface-A p-12 opacity-0 transition-opacity sm:w-2/3 md:w-3/5 lg:w-2/5"
        [ngClass]="{
            'opacity-100': showContent(),
        }"
    >
        <div class="flex w-full items-center justify-end">
            <button
                interacta-icon-button
                type="button"
                [icon]="'minus'"
                [label]="'AI.MINIMIZE' | translate"
                [size]="'regular'"
                [style]="'text'"
                (click)="close()"
            ></button>
        </div>
        <div class="grow overflow-hidden">
            <interacta-ai-panel />
        </div>
    </section>
</div>
